import { render, staticRenderFns } from "./AddSkillAssessment.vue?vue&type=template&id=550f222c&scoped=true&"
import script from "./AddSkillAssessment.vue?vue&type=script&lang=js&"
export * from "./AddSkillAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550f222c",
  null
  
)

export default component.exports